import {active} from "./const.js";

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".js-tabList").forEach((tabList) => {
    const tabs = tabList.querySelectorAll(".js-tab");

    tabs.forEach((tab, index) => {
      tab.addEventListener("click", function () {
        // 親要素から対応するコンテンツブロックを取得
        const guidelineContent = tabList.nextElementSibling;
        if (!guidelineContent) return;

        const tabContents = guidelineContent.querySelectorAll(".js-tabContent");

        // すべてのタブとコンテンツから -active を削除
        tabs.forEach((t) => t.classList.remove(active));
        tabContents.forEach((content) => content.classList.remove(active));

        // クリックされたタブと対応するコンテンツに -active を追加
        tab.classList.add(active);
        if (tabContents[index]) {
          tabContents[index].classList.add(active);
        }
      });
    });
  });
});
